// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"354e0bde","701":"405f73f3","732":"3cbc5c92","852":"e11a3155","977":"a0848d9b"}[chunkId] + ".chunk.js";
};